import Phaser from "phaser"

export const eventsCenter = new Phaser.Events.EventEmitter()
